"use client";

import React from "react";

interface InlineLoaderProps {
  size?: "sm" | "md" | "lg";
  color?: "orange" | "white" | "gray";
  showText?: boolean;
  text?: string;
  className?: string;
}

const InlineLoader: React.FC<InlineLoaderProps> = ({
  size = "sm",
  color = "orange",
  showText = true,
  text = "Loading...",
  className = "",
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };

  const colorClasses = {
    orange: "border-orange-500 border-t-transparent",
    white: "border-white border-t-transparent",
    gray: "border-gray-400 border-t-transparent",
  };

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <div
        className={`${sizeClasses[size]} border-2 ${colorClasses[color]} rounded-full animate-spin`}
      />
      {showText && <span className="text-sm">{text}</span>}
    </div>
  );
};

export default InlineLoader;
